"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _parseFormValues = require("./parseFormValues");
Object.keys(_parseFormValues).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _parseFormValues[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _parseFormValues[key];
    }
  });
});
